__turbopack_context__.v({
  "banner": "ProgramBanner-module-scss-module__5X0rpG__banner",
  "ctaButton": "ProgramBanner-module-scss-module__5X0rpG__ctaButton",
  "description": "ProgramBanner-module-scss-module__5X0rpG__description",
  "imgBanner": "ProgramBanner-module-scss-module__5X0rpG__imgBanner",
  "imgBlob": "ProgramBanner-module-scss-module__5X0rpG__imgBlob",
  "leftContent": "ProgramBanner-module-scss-module__5X0rpG__leftContent",
  "title": "ProgramBanner-module-scss-module__5X0rpG__title",
  "visualSide": "ProgramBanner-module-scss-module__5X0rpG__visualSide",
  "wrapper": "ProgramBanner-module-scss-module__5X0rpG__wrapper",
});
